import React from 'react';
import appData from './data';

export const AppContext = React.createContext();

export class AppProvider extends React.Component {
  state = { ...appData };

  render() {
    return (
      <AppContext.Provider value={{ ...this.state }}>
        <section>
          { this.props.children }
        </section>
      </AppContext.Provider>
    );
  }
}
